<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onClose">
		<div slot="header">
			<translate>Connect Logs</translate>
		</div>
		<div slot="content" class="work-log-view" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
			<el-row type="flex" justify="center" class="connect-log-row log-title">
				<el-col :span="7" class="p-l-5"><translate>UserName</translate></el-col>
				<el-col :span="5"><translate>Connection IP</translate></el-col>
				<el-col :span="5"><translate>Connection Time</translate></el-col>
				<el-col :span="3"><translate>Duration</translate></el-col>
				<el-col :span="2"><translate>Action</translate></el-col>
			</el-row>
			<el-row type="flex" class="connect-log-row" justify="center" v-if="logs && logs.length < 1">
				<el-col class="no-data"><translate>No Data</translate></el-col>
			</el-row>
			<el-row type="flex" class="connect-log-row" justify="center" v-if="!logs">
				<img class="loading" src="../../../assets/loading.gif" />
			</el-row>
			<el-row type="flex" class="connect-log-row" justify="center" v-if="logs && logs.length > 0" v-for="log in logs" :key="log.id">
				<el-col :span="6">
					<div class="avatar-box">
						<img class="avatar" :src="log.avatar | resetURL" border="0" />
						<div class="pull-left avatar-info">
							<div class="wrap">
								{{ log.account_name }}
							</div>
							<div class="p-t-5 text-ellipsis">{{ log.account }}</div>
						</div>
					</div>
				</el-col>
				<el-col :span="1">
					<div style="color: red; line-height: 36px">
						<el-tooltip class="item" effect="dark" :content="attrText.unsafeMode" placement="top" v-if="log.unsafe_mode === 1">
							<i class="fa fa-exclamation-circle warn"></i>
						</el-tooltip>
					</div>
				</el-col>
				<el-col class="flex-box" :span="5">
					<span>{{ log.client_ip_address || '-' }}</span>
				</el-col>
				<el-col class="flex-box text-center" :span="5">
					<span>{{ (log.start_date * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</span>
				</el-col>
				<el-col class="flex-box text-right" :span="3">{{ log.totalTime }}</el-col>
				<el-col class="flex-box text-center" :span="3">
					<a v-if="log.way != 'rds' && log.way != 'mysql' && log.way != 'mssql' && log.way != 'postgresql' && log.way != 'oracle' && log.way != 'transfer' && log.play != 0 && log.date > log.start_date" target="_blank" :href="log.playbackLink"><translate>Play</translate></a>
					<a v-if="log.way == 'transfer'" class="view-url" @click="viewLog(log)">
						<translate>View</translate>
					</a>
					<a v-if="(log.way == 'rds' || log.way == 'mysql' || log.way == 'mssql' || log.way == 'postgresql' || log.way == 'oracle') && log.date >= log.start_date" :href="log.downloadLink"><translate>Download</translate></a>
				</el-col>
			</el-row>
			<!--<div class="text-center l-h-32">-->
			<!--<translate>To view the full mode, click the View Full Mode button</translate>-->
			<!--</div>-->
		</div>
		<div slot="footer">
			<el-button type="primary" @click="onShowAll()"><translate>Show All</translate></el-button>
		</div>
	</right-panel>
</template>
<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import { baseUrl } from '../../../config'
import Utility from '../../../Utils'
export default {
	name: 'WorkGroupConnectLogs',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			logs: null,
			data: [],
			count: 0,
			busy: false,
			loading: true,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	mounted() {},
	created() {},
	methods: {
		getTranslateText() {
			return {
				unsafeMode: this.$gettext('Unsafe Mode'),
			}
		},
		onShowAll() {
			console.log('this.connects==>', this.connects)
			this.$router.push({ name: 'logs', query: { resourceName: `${this.connects.id}:${this.connects.name}` } })
		},
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
		getConnectLog(page, id) {
			const params = {
				page_index: page || 1,
				page_size: 10,
				resource_id: id,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CONNECT_LOG, params).then(
				(res) => {
					console.log('connect-->log', res)
					console.log('language', this.$language.current)
					res.data.forEach((item) => {
						let _playbackLink = 'playlog.html'
						let _downloadLink = baseUrl.apiUrl + '/download_tunnel_log'
						_playbackLink += '#?link=' + baseUrl.apiUrl
						_playbackLink += '&way=' + item.way
						_playbackLink += '&code=' + item.code
						_playbackLink += '&resource_id=' + item.resource_id
						_playbackLink += '&account_name=' + item.account_name
						_playbackLink += '&avatar=' + item.avatar
						_playbackLink += '&account_id=' + item.account_id
						_playbackLink += '&start_time=' + item.start_date
						_playbackLink += '&date=' + item.date
						_downloadLink += '?way=' + item.way
						_downloadLink += '&code=' + item.code
						_downloadLink += '&start_time=' + item.start_date
						if (item.guacamole) {
							_playbackLink += '&guacamole=' + item.guacamole
							if (item.rdp_width && item.rdp_height) {
								_playbackLink += '&rdp_width=' + item.rdp_width
								_playbackLink += '&rdp_height=' + item.rdp_height
							}
						}
						if (item.connection_id) {
							_playbackLink += '&connection_id=' + item.connection_id
							_downloadLink += '&connection_id=' + item.connection_id
						}
						if (item.agent_version) {
							_playbackLink += '&version=' + Utility.Utils.getAgentVersion(item.agent_version)
						}
						_playbackLink += '&lang=' + this.$language.current
						_playbackLink += '&type=playlog'
						item.playbackLink = _playbackLink
						item.downloadLink = _downloadLink
						if (item.date - item.start_date > 0) {
							let ff = item.date - item.start_date
							let h = Math.floor(ff / 3600)
							let m = Math.floor((ff % 3600) / 60)
							let s = ff % 60
							if (h < 10) {
								h = '0' + h
							}
							if (m < 10) {
								m = '0' + m
							}
							if (s < 10) {
								s = '0' + s
							}
							item.totalTime = h + ':' + m + ':' + s
							console.log(item.totalTime)
						} else {
							item.totalTime = '00:00:00'
						}
					})
					this.logs = res.data
					console.log('logs', this.logs, baseUrl)
				},
				() => {
					this.logs = []
				},
			)
		},
		loadMore() {
			this.busy = true
			console.log('load more')
			this.busy = false
		},

		// 查看日志 - 触发父组件的弹窗
		viewLog(row) {
			console.log('=== 子组件 viewLog 被调用 ===')
			console.log('row data:', row)
			// 触发父组件的方法，由父组件来显示弹窗
			this.$emit('onViewLog', row)
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
						this.getConnectLog(1, this.connects.id)
					}, 300)
				} else {
					this.connects = this.items
					this.getConnectLog(1, this.connects.id)
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';
.work-log-view {
	border-top: 1px solid $border-color;
	border-left: 1px solid $border-color;
	border-right: 1px solid $border-color;
	height: 100%;
	.l-h-32 {
		line-height: 32px;
	}
	a {
		color: $mainColor;
	}
	.no-data {
		line-height: 60px;
		text-align: center;
	}
	.log-title {
		line-height: 36px;
		font-weight: bold;
	}
	.avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		margin: 12px 5px 12px 5px;
		float: left;
	}
	.avatar-info {
		width: 70%;
		position: absolute;
		left: 45px;
		top: 10px;
		.wrap {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		.item {
			color: red;
		}
	}
	.avatar-box {
		width: 100%;
		overflow: hidden;
		position: relative;
	}
	.flex-box {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.text-ellipsis {
		width: 90%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.p-l-5 {
		padding-left: 5px;
	}
	.p-t-5 {
		padding-top: 5px;
	}
	.l-h-40 {
		line-height: 40px;
	}
	.l-h-60 {
		line-height: 60px;
	}
	.connect-log-row {
		border-bottom: 1px solid $border-color;
		.loading {
			display: block;
			margin: 20px auto;
			width: 68px;
			height: 68px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// workgroup-connection-logs.vue?5a3b0260